<via-button-bar [showCancelModal]="true" [modalType]="modalType"></via-button-bar>
<via-progress-bar [currentStep]="3"></via-progress-bar>
<via-loading-spinner *ngIf="loading"></via-loading-spinner>

<div class="e-save-extraction-layout" role="main">
    <div class="e-save-extraction-options">
        <h2>Save My Extraction</h2>
        <p>Give your extraction a title and an optional description.</p>

        <label for="titleInput">Title <span>(Required)</span></label>
        <input id="titleInput" [(ngModel)]="title" (blur)="saveTitle(title)" maxlength="256" />

        <label for="descriptionInput">Description <span>(Optional)</span></label>
        <textarea id="descriptionInput" [(ngModel)]="description" (blur)="saveDescription(description)" maxlength="512"></textarea>
    </div>
    <div class="e-action-bar">
        <via-sku-count></via-sku-count>
        <via-action-bar
            [showCompleteButton]="true"
            [isCompleteButtonDisabled]="hasInvalidTitle()"
            (onApplyClicked)="completeExtraction()">
        </via-action-bar>
    </div>
</div>
